export default __webpack_public_path__ + "static/media/default-brand.da4387ae.svg";